import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'map',
    standalone: false
})
export class MapPipe implements PipeTransform {
  public transform(value: string, fn: (arg: any) => string): string {
    return fn(value)
  }
}
